import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { "element-loading-text": "正在提交数据，请稍后" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("停用")

import { ref, unref, reactive, onMounted } from 'vue';
import { FormRules, ElMessage, ElForm } from 'element-plus';
import { GbDialog } from '@/components/GbDialog/Index';
import { useLocales } from '@/hooks/useLocales';
import { useDictionary } from '@/store/dictionary.store';
import { useUser } from '@/store/user.store';
import { GetStampDetailApi, StampCreateApi, StampModifyApi } from '@/apis/basics/stamps.api';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const { t } = useLocales();
const userStore = useUser();
const { getSelectList } = useDictionary();
const formRef = ref<ComponentRef<typeof ElForm>>();

const state = reactive({
	show: false,
	loading: false,
	isEditor: false,
	userList: [] as any[],
	title: '印章',
});

const formSchema = ref<any>({});

/* 表单验证规则 */
const formRules: FormRules = {
	stamp_no: [{ required: true, message: '印章编号不能留空', trigger: 'blur' }],
	stamp_name: [{ required: true, message: '印章名称不能留空', trigger: 'blur' }],
	stamp_type: [{ required: true, message: '请选择印章类型', trigger: 'blur' }],
	mainstay_id: [{ required: true, message: '印章所属公司不能留空', trigger: 'blur' }],
	managers_id: [{ required: true, message: '请选择管章人', trigger: 'blur' }],
	managers_mb: [{ required: true, message: '管章人电话不能留空', trigger: 'blur' }],
};

const exposeFuncs = {
	/* 创建 */
	create: (mainstayId: string) => {
		formSchema.value = Object.assign({
			id: '',
			mainstay_id: mainstayId,
			revision: '0',
			stamp_no: '',
			stamp_name: '',
			remark: '',
			using_range: '',
			stamp_type: '',
			is_enabled: 'Y',
			managers_id: '',
			managers_mb: '',
			is_define: 'Y',
		});

		state.title = '新增印章';
		state.isEditor = false;
		state.show = true;
	},

	/* 创建 */
	modify: async (rowId: any) => {
		state.loading = true;
		const { succeeded, errors, data } = await GetStampDetailApi(rowId);
		state.loading = false;

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			formSchema.value = Object.assign({}, data);
		}

		state.title = '编辑印章';
		state.isEditor = true;
		state.show = true;
	},
};

const onUserSelect = (user: any) => {
	unref(formSchema).managers_id = user[0].id;
};

/* 点击保存按钮 */
const onSaveBtnClick = () => {
	const formData = unref(formSchema);
	const api = !unref(state.isEditor) ? StampCreateApi : StampModifyApi;

	unref(formRef)?.validate(async (valid: boolean) => {
		if (!valid) return;

		state.loading = true;
		const { succeeded, errors } = await api(formData);
		state.loading = false;

		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			ElMessage.success('保存成功');
			state.show = false;
			$emits('refresh');
		}
	});
};

expose({ ...exposeFuncs });

onMounted(() => {
	state.userList = userStore.getSelectList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(state).show) = $event)),
    title: _unref(state).title,
    style: {"width":"680px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        disabled: _unref(state).loading,
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        size: "small",
        type: "info",
        disabled: _unref(state).loading,
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.closed')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          size: "small",
          ref_key: "formRef",
          ref: formRef,
          "label-width": "100px",
          model: formSchema.value,
          "label-position": 'right',
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "印章编号",
                      prop: "stamp_no"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.stamp_no,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.stamp_no) = $event)),
                          type: "text",
                          placeholder: "请输入印章编号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "印章名称",
                      prop: "stamp_name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.stamp_name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.stamp_name) = $event)),
                          type: "text",
                          placeholder: "请输入印章名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "印章类型",
                      prop: "stamp_type"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formSchema.value.stamp_type,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.stamp_type) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectList)('stamp_type'), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "管章人",
                      prop: "managers_id"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select_v2, {
                          class: "w100",
                          modelValue: formSchema.value.managers_id,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.managers_id) = $event)),
                          options: _unref(state).userList,
                          clearable: "",
                          filterable: "",
                          placeholder: "请选择管章人",
                          "tag-type": "primary"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "联系电话",
                      prop: "managers_mb"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.managers_mb,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.managers_mb) = $event)),
                          type: "text",
                          placeholder: "请输入印章名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "默认用印",
                      prop: "is_define"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formSchema.value.is_define,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.is_define) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "Y" }, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "N" }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "状态",
                      prop: "is_enabled"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formSchema.value.is_enabled,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.is_enabled) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "Y" }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "N" }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "备注",
                      prop: "remark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.remark,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.remark) = $event)),
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "150",
                          rows: "4",
                          placeholder: "备注"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})